/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  hasMany,
  type AsyncBelongsTo,
  type AsyncHasMany,
} from '@warp-drive/legacy/model';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type { EnumValue } from '@linc-technologies/linced-common/enums/base-enum';
import CommentModerationStatus from '@linc-technologies/linced-common/enums/comment-moderation-status';
import type PostType from '@linc-technologies/linced-common/enums/post-type';
import type Person from '@linc-technologies/linced-common/models/person';
import type Post from '@linc-technologies/linced-common/models/posts/post';
import type Reaction from '@linc-technologies/linced-common/models/posts/reaction';

// Proto: posts.Comment.
export default class Comment extends Model {
  declare [Type]: 'posts/comment';

  // Attrs
  @attr('number')
  declare createTime: number | undefined;

  @attr('number')
  declare updateTime: number | undefined;

  @attr('string', { defaultValue: '' })
  declare schoolId: string;

  @belongsTo('person', { async: true, inverse: null })
  declare authorId: AsyncBelongsTo<Person>;

  @alias('authorId')
  declare author: AsyncBelongsTo<Person>;

  @attr('number', { defaultValue: 0 })
  declare postType: EnumValue<typeof PostType> | 0;

  @belongsTo('posts/post', { async: true, inverse: 'comments' })
  declare postId: AsyncBelongsTo<Post>;

  @alias('postId')
  declare post: AsyncBelongsTo<Post>;

  @belongsTo('posts/comment', { async: true, inverse: 'replies' })
  declare commentId: AsyncBelongsTo<Comment>;

  @alias('commentId')
  declare inReplyTo: AsyncBelongsTo<Comment>;

  @attr('string', { defaultValue: '' })
  declare content: string;

  @hasMany('posts/comment', { async: true, inverse: 'commentId' })
  declare replies: AsyncHasMany<Comment>;

  @hasMany('posts/reaction', { async: true, inverse: 'commentId' })
  declare reactions: AsyncHasMany<Reaction>;

  @belongsTo('person', { async: true, inverse: null })
  declare moderatorId: AsyncBelongsTo<Person>;

  @attr('number', {
    defaultValue: CommentModerationStatus.UNSPECIFIED,
  })
  declare moderationStatus: EnumValue<typeof CommentModerationStatus>;
}
